<div class="container py-3">
  <h2 class="mb-3">License Admin</h2>
  <div class="row g-4">
    <!-- Left: License list (60%) -->
    <div class="col-lg-7">
      <div class="subsection">
        <div class="d-flex justify-content-between align-items-center mb-2 subheader">
          <h4 class="m-0 subsection-title">License list</h4>
        </div>
        <div class="d-flex align-items-center mb-2 gap-2">
          <input class="form-control form-control-sm w-25" [(ngModel)]="keywords" placeholder="Search keywords"/>
          <button class="btn btn-sm btn-outline-primary" (click)="fetchList(true)">Search</button>
          <button class="btn btn-sm btn-warning" (click)="onDeactivateBatch()" *ngIf="isAdmin" [disabled]="deactivating">{{ deactivating ? 'Deactivating...' : 'Deactivate Batch' }}</button>
          <button class="btn btn-sm btn-success" (click)="openAddDialog()" *ngIf="isAdmin">Add</button>
          <button class="btn btn-sm btn-danger" [disabled]="!selected" (click)="onDelete()" *ngIf="isAdmin">Delete</button>
        </div>

        <div class="table-responsive border rounded">
          <table class="table table-sm table-hover align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th>ID</th>
                <th>Purchase Email</th>
                <th>License Key</th>
                <th>Product</th>
                <th>Period</th>
                <th>Type</th>
                <th>Purchase Date</th>
                <th>Activated</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let it of items" (click)="selectRow(it)" [class.table-active]="selected?.licenseId===it.licenseId" style="cursor:pointer;">
                <td>{{ it.licenseId }}</td>
                <td>{{ it.purchaseEmail }}</td>
                <td>{{ it.licenseKey }}</td>
                <td>{{ it.productId }}</td>
                <td>{{ it.period }}</td>
                <td>{{ it.periodType }}</td>
                <td>{{ (it.purchaseDate | date:'yyyy-MM-dd') || '' }}</td>
                <td>{{ it.activated ? 'Yes' : 'No' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-2">
          <div>Page {{ page+1 }} / {{ totalPages }} ({{ total }} items)</div>
          <div>
            <button class="btn btn-sm btn-outline-secondary me-2" (click)="goPrev()" [disabled]="page===0">Prev</button>
            <button class="btn btn-sm btn-outline-secondary" (click)="goNext()" [disabled]="page+1>=totalPages">Next</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Right: License details -->
    <div class="col-lg-5" *ngIf="selected">
      <div class="subsection">
        <div class="d-flex justify-content-between align-items-center mb-2 subheader">
          <h4 class="m-0 subsection-title">License Details</h4>
          <div *ngIf="isAdmin">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" [(ngModel)]="editMode">
              <label class="form-check-label">Edit</label>
            </div>
          </div>
        </div>

        <div class="row g-2">
          <div class="col-12 col-md-6">
            <label class="form-label">License ID</label>
            <input class="form-control form-control-sm" [value]="selected.licenseId" readonly>
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">License Key</label>
            <input class="form-control form-control-sm" [value]="selected.licenseKey" readonly>
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">Activated</label>
            <select class="form-select form-select-sm" [(ngModel)]="selected!.activated" [disabled]="!editMode || !isAdmin">
              <option [ngValue]="true">true</option>
              <option [ngValue]="false">false</option>
            </select>
          </div>

          <div class="col-12 col-md-6">
            <label class="form-label">Purchase Email</label>
            <input class="form-control form-control-sm" [(ngModel)]="selected!.purchaseEmail" [disabled]="!editMode || !isAdmin">
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">Product Id</label>
            <select class="form-select form-select-sm" [(ngModel)]="selected!.productId" [disabled]="!editMode || !isAdmin">
              <option value="ntrip-pro">ntrip-pro</option>
              <option value="ntrip-ent">ntrip-ent</option>
              <option value="analyzer">analyzer</option>
              <option value="ntrip-basic">ntrip-basic</option>
              <option value="analyzer-pro">analyzer-pro</option>
              <option value="downloader-pro">downloader-pro</option>
              <option value="downloader">downloader</option>
            </select>
          </div>

          <div class="col-12 col-md-4">
            <label class="form-label">Period</label>
            <input type="number" class="form-control form-control-sm" [(ngModel)]="selected!.period" [disabled]="!editMode || !isAdmin">
          </div>
          <div class="col-12 col-md-4">
            <label class="form-label">Period Type</label>
            <select class="form-select form-select-sm" [(ngModel)]="selected!.periodType" [disabled]="!editMode || !isAdmin">
              <option value="D">D</option>
              <option value="M">M</option>
              <option value="Y">Y</option>
            </select>
          </div>
          <div class="col-12 col-md-4">
            <label class="form-label">User Id</label>
            <input class="form-control form-control-sm" [(ngModel)]="selected!.userId" [disabled]="!editMode || !isAdmin">
          </div>

          <div class="col-12 col-md-6">
            <label class="form-label">Purchase Date</label>
            <input type="date" class="form-control form-control-sm" [ngModel]="selected.purchaseDate | date:'yyyy-MM-dd'" (ngModelChange)="selected!.purchaseDate = $event" [disabled]="!editMode || !isAdmin">
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">Activation Date</label>
            <input type="date" class="form-control form-control-sm" [ngModel]="selected.activationDate | date:'yyyy-MM-dd'" (ngModelChange)="selected!.activationDate = $event" [disabled]="!editMode || !isAdmin">
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">Deactivation Date</label>
            <input type="date" class="form-control form-control-sm" [ngModel]="selected.deactivationDate | date:'yyyy-MM-dd'" (ngModelChange)="selected!.deactivationDate = $event" [disabled]="!editMode || !isAdmin">
          </div>
        </div>

        <div class="mt-3 d-flex justify-content-end" *ngIf="isAdmin">
          <button class="btn btn-sm btn-primary" [disabled]="!editMode" (click)="onSave()">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>


